import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Root,
  Title,
  Container,
  Grid,
  Item,
  ItemImage,
  ItemContent,
  Name,
  CompanyName,
  Review,
} from './EducationSuccessStories.style';

import { config } from './config';

import { Button } from '../../ui/Button/Button';
import { Link } from '../Link/Link';

export const EducationSuccessStories = () => {
  return (
    <Root>
      <Title>
        <FormattedMessage defaultMessage="SUCCESS STORIES" />
      </Title>
      <Container>
        <Grid>
          {config.map(({ imgSrc, name, companyName, review }, idx) => (
            <Item key={idx}>
              <ItemImage src={imgSrc} alt={name} />
              <ItemContent>
                <Name>{name}</Name>
                <CompanyName>{companyName}</CompanyName>
                <Review>{review}</Review>
              </ItemContent>
            </Item>
          ))}
        </Grid>
      </Container>
      {/* <Button
        as={Link}
        to="/education/stories"
        style={{ backgroundColor: '#e74391' }}
      >
        <FormattedMessage defaultMessage="VIEW MORE STORIES" />
      </Button> */}
    </Root>
  );
};
